<template>
  <card shadow>
    <h5 class="h3 title">
      <span class="d-block mb-3">Pending Organizations</span>
    </h5>
    <div class="table-responsive">
      <table class="table table-flush">
        <thead>
          <tr>
            <th>Name</th>
            <th>Type</th>
            <th>Email</th>
            <th>Phone</th>
            <th>Description</th>
            <th>Needs</th>
            <th>User Name</th>
            <th>User Email</th>
            <th class="text-right">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="pendingOrg in pendingOrgs" v-bind:key="pendingOrg.id">
            <td>{{pendingOrg.name}}</td>
            <td>{{pendingOrg.type | capitalize}}</td>
            <td>{{pendingOrg.email}}</td>
            <td>{{pendingOrg.phone}}</td>
            <td>{{pendingOrg.description}}</td>
            <td>{{pendingOrg.needs}}</td>
            <td>{{pendingOrg.addedByUser.name}}</td>
            <td>{{pendingOrg.addedByUser.email}}</td>
            <td class="td-actions text-right">
              <button
                type="button"
                rel="tooltip"
                class="btn btn-success btn-icon btn-sm"
                data-original-title
                @click="acceptPendingOrg(pendingOrg)"
                title
              >
                <i class="ni ni-check-bold pt-1"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </card>
</template>

<script>
import firebase from "@/config/firebase.js";

export default {
  name: "pendingorgcard",
  data() {
    return {
      pendingOrgs: []
    };
  },
  methods: {
    declinePendingOrg(organization) {},
    acceptPendingOrg(organization) {
      const finalOrgData = {
        name: organization.name,
        type: organization.type,
        email: organization.email,
        phone: organization.phone,
        description: organization.description,
        needs: organization.needs,
        addedByUser: organization.addedByUser.id
      };
      const userData = {
        name: organization.addedByUser.name,
        email: organization.addedByUser.email,
        id: organization.addedByUser.id,
        orgId: organization.id
      };

      firebase
        .firestore()
        .doc(`organizations/${organization.id}`)
        .set(finalOrgData)
        .then(() => {
          firebase
            .firestore()
            .doc(`pendingOrganizations/${organization.id}`)
            .delete()
            .then(() => {
              this.getPendingOrgs();
            })
            .catch(function(error) {
              console.error("Error removing document: ", error);
            });

          firebase
            .firestore()
            .doc("organizations/" + organization.id + "/users/" + userData.id)
            .set(userData)
            .catch(function(error) {
              console.error("Error removing document: ", error);
            });

          firebase
            .firestore()
            .doc("organizations/" + organization.id + "/roles/" + userData.id)
            .set({
              enrollUser: true,
              userRead: true,
              userUpdate: true,
              roleRead: true,
              roleChange: true,
              potentialeeChange: true,
              enrollPotentialee: true,
              jobChange: true,
              createJob: true,
              deleteJob: true,
              resourceChange: true,
              createResource: true,
              deleteResource: true,
              deletePotentialee: true
            })
            .catch(function(error) {
              console.error("Error removing document: ", error);
            });
        })
        .catch(function(error) {
          console.error(error);
        });
    },
    getPendingOrgs() {
      firebase
        .firestore()
        .collection("pendingOrganizations")
        .get()
        .then(querySnapshot => {
          const documents = querySnapshot.docs.map(doc => {
            const docData = doc.data();
            docData.id = doc.id;

            return docData;
          });

          this.pendingOrgs = documents;
        });
    }
  },
  filters: {
    capitalize: function(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  },
  mounted() {
    this.getPendingOrgs();
  }
};
</script>

<style scoped>
</style>
